import * as React from 'react';

import {colors} from 'shells/colors/colors';
import {Illustration} from 'shells/illustrations/illustration';
import {ImageWrapper} from 'shells/onboarding-modal/image-wrapper';
import {OnboardingModal} from 'shells/onboarding-modal/onboarding-modal';

import {OpenableModals, useOpenableModal} from '../../../openable-modals';

// @ts-expect-error
import {Intro, Identify, Filter, GetStarted} from './pages';

export function VisitorIQOnboardingModal() {
    const {isOpen, onClose} = useOpenableModal(OpenableModals.VISITOR_IQ_ONBOARDING_MODAL);

    if (!isOpen) {
        return null;
    }

    const pages = [
        {
            id: 'intro',
            body: <Intro />,
            art: {
                background: colors.plumLt,
                image: () => (
                    <ImageWrapper
                        image={<Illustration src='introducing-visitor-iq' />}
                        width={220}
                    />
                ),
            },
        },
        {
            id: 'identify',
            body: <Identify />,
            art: {
                background: colors.plumLt,
                image: () => (
                    <ImageWrapper
                        image={<Illustration src='identifying-companies' />}
                        width={220}
                    />
                ),
            },
        },
        {
            id: 'filter',
            body: <Filter />,
            art: {
                background: colors.plumLt,
                image: () => (
                    <ImageWrapper image={<Illustration src='filtering-noise' />} width={220} />
                ),
            },
        },
        {
            id: 'get-started',
            body: <GetStarted onClose={onClose} />,
            art: {
                background: colors.plumLt,
                image: () => (
                    <ImageWrapper image={<Illustration src='code-snippet' />} width={220} />
                ),
            },
        },
    ];

    return (
        <OnboardingModal
            onClose={onClose}
            onFinish={onClose}
            canClickOutsideToClose={true}
            pages={pages}
            lastButtonText='Got it'
        />
    );
}
